<template>
  <nav>
    <button
      v-if="!isFirst"
      class="prev"
      @click="$emit('change', currentPage - 1)"
    >
      <img
        loading="lazy"
        class="icon"
        src="@/assets/images/forward-rounded-blue.svg"
        alt=""
        width="8"
        height="15"
      />
      <translate>Previous</translate>
    </button>
    <div class="summary" :class="{ end: isLast }">
      Page {{ currentPage }} of {{ totalPages }}
    </div>
    <button
      v-if="!isLast"
      class="next"
      @click="$emit('change', currentPage + 1)"
    >
      <translate>Next</translate>
      <img
        loading="lazy"
        class="icon"
        src="@/assets/images/forward-rounded-blue.svg"
        alt=""
        width="8"
        height="15"
      />
    </button>
  </nav>
</template>
<script lang="ts">
import { PaginationData, validatePaginationData } from '~/utility/pagination'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { reportError } from '~/utility/reportError'

@Component
class PaginationControls extends Vue {
  @Prop({
    required: true,
    validator: (v) => {
      try {
        validatePaginationData(v)
        return true
      } catch (err) {
        reportError(err as Error)
        return false
      }
    },
  })
  paginationData: PaginationData

  get currentPage() {
    return this.paginationData.currentPage
  }

  get totalPages() {
    return this.paginationData.totalPages
  }

  get isFirst() {
    return this.currentPage === 1
  }

  get isLast() {
    return this.currentPage === this.totalPages
  }
}

export default toNative(PaginationControls)
</script>

<style scoped>
nav {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1.4em;
}

.summary,
button {
  font-size: var(--body);
  border: 1px solid var(--colour-page-background);
  color: var(--colour-blue);
  background-color: white;
}

.summary {
  padding: 0.5em 1em;
  flex-shrink: 0;
  color: var(--colour-text-light);
  border-radius: 1em 0 0 1em;
}

.prev + .summary {
  border-radius: 0;
}

.summary.end {
  border-radius: 0 1em 1em 0;
}

button {
  padding: 0.5em 1em;
  margin: 0;
  box-shadow: none;
  border-radius: 1em;
  cursor: pointer;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon {
  width: auto;
  height: 1em;
  margin: 0 0 0 0.5em;
}

.prev .icon {
  transform: rotate(180deg);
  margin: 0 0.5em 0 0;
}

button:not(:last-child) {
  border-right: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

button:not(:first-child) {
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

button:active {
  background-color: var(--colour-form-blue);
  transform: translateY(0);
  color: white;
}
</style>
